// Shared by the motion modules: whether the visitor allows motion. Sets html.has-motion while they do, so the CSS
// only hides or shifts anything (the unfilled headline parts, the dimmed quote words) when a script will bring it
// back. Without JS or with reduced motion every text shows in its final colours.
export const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

export function initMotion() {
	const update = () => document.documentElement.classList.toggle('has-motion', !reducedMotion.matches)
	reducedMotion.addEventListener('change', update)
	update()
}

// Calls `show` once per element when it scrolls into view (a little above the window's bottom edge).
export function onceVisible(elements, show, rootMargin = '0px 0px -12% 0px') {
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return
				observer.unobserve(entry.target)
				show(entry.target)
			})
		},
		{ rootMargin },
	)
	elements.forEach((element) => observer.observe(element))
}
